import { formatDateForAPI } from "@utils/datetime";

export const getJustificationHistory =
  (fetch: Client.HttpClient) => (date: string, processDefinitionId: number) =>
    fetch.get<Sentinel.DelayManagement.JustificationHistoryItem[]>(
      `/api/justification/${date}/${processDefinitionId}`
    );

export const createJustification =
  (fetch: Client.HttpClient) =>
  (processDefinitionId: number, data: Sentinel.Justification.CreateRequest) =>
    fetch.post<
      Sentinel.Justification.CreateRequest,
      Sentinel.Justification.Response
    >(`/api/${processDefinitionId}/justification`, { body: data });

export const getLastJustification =
  (fetch: Client.HttpClient) => (date: Date, processDefinitionId: number) =>
    fetch.get<Sentinel.Justification.LastResponse>(
      `/api/justification/last/${formatDateForAPI(date)}/${processDefinitionId}`
    );
